import { FireCell } from '@firesim/simkit-core';
import type { Plane } from '@firesim/simkit-core';
import type {Config} from './config';
import { TerrainCodes } from './terrain-types';

const activeClass = '.reload-btn--active';

async function resetPlane(plane: Plane<TerrainCodes, FireCell<TerrainCodes>>): Promise<void> {

    await plane.reset({
        clearLayers: ['fire']
    });
    // Clear out burned cells
    plane.cells.forEach(
        (col: FireCell<TerrainCodes>[]) => col.forEach(
            (cell) => {
                cell.isBurned = false;
            }
        )
    );
}

export function bindLoadButton(button: HTMLButtonElement, plane: Plane<TerrainCodes, FireCell<TerrainCodes>>, callback: () => void) {
	button.addEventListener('click', (evt) => {
		evt.preventDefault();
		button.disabled = true;
		button.classList.add(activeClass);
		resetPlane(plane);
		button.classList.remove(activeClass);
		button.disabled = false;
		if(callback) {
			callback();
		}
	});
}

